import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';

import { View } from 'backbone';

import imageImportPositionTemplate from 'properties/main/image-import-button-position.ejs';

class MainImageButtonPositionView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.tagName = 'div';
        this.id = opts.el;
        this.template=imageImportPositionTemplate;

        this.events = {
            'change input[type=checkbox]' : 'updateCheckboxAttributes'
        };

        if(this.model.get('buttonPositionAbove') === undefined){
            this.model.set('buttonPositionAbove','false', {silent: true});
        }
        
        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateCheckboxAttributes(ev) {
        ev.preventDefault();
        const propVal  = ev.currentTarget.checked;
            if (propVal) {
                this.model.set('buttonPositionAbove', 'true');
            } else {
                this.model.set('buttonPositionAbove','false');
            }
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }

}

export default MainImageButtonPositionView;
